module.exports = __webpack_public_path__ + "static/media/boosting.8c4f7b59.svg";